"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Chip_1 = __importDefault(require("@material-ui/core/Chip"));

exports.default = function (props) {
  var success = props.success,
      text = props.text;
  var backgroundColor = success ? '#388e3c' : '#ffc107';
  var style = {
    backgroundColor: backgroundColor,
    color: '#fff'
  };
  return react_1.default.createElement(Chip_1.default, {
    label: text,
    style: style
  });
};